module.exports = __webpack_public_path__ + "static/media/licence_installation.388d27d4.PNG";